import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import List from "@/components/List.vue";
import GoodsItem from "@/components/GoodsItem.vue";
import Classify from "../../components/Classify.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";
export default {
  name: "Goods",
  components: {
    List: List,
    GoodsItem: GoodsItem,
    Classify: Classify,
    SearchKeyWords: SearchKeyWords
  },
  data: function data() {
    return {
      classify: 0,
      sub_classify: 0,
      classifyList: [],
      searchCondition: {
        order: "id",
        sort: "desc",
        recommend: this.$route.query.recommend
      }
    };
  },
  computed: {
    sort: function sort() {
      return this.searchCondition.order;
    },
    direct: function direct() {
      return this.searchCondition.sort;
    }
  },
  watch: {
    $route: function $route() {
      this.$refs.list.searchRefresh();
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$http.get("/api/app/goods/classify");

            case 2:
              this.classifyList = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  // mounted() {
  //   this.$kefu()
  // },
  methods: {
    onClassifyChange: function () {
      var _onClassifyChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref) {
        var value;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                value = _ref.value;
                this.classify = value.item;
                this.sub_classify = value.child;
                this.$refs.list.searchRefresh();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onClassifyChange(_x) {
        return _onClassifyChange.apply(this, arguments);
      }

      return onClassifyChange;
    }(),
    changeSort: function () {
      var _changeSort = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(sort) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.searchCondition.order = sort;

                if (sort == "price") {
                  this.searchCondition.sort = this.searchCondition.sort == "desc" ? "asc" : "desc";
                } else {
                  this.searchCondition.sort = "desc";
                }

                this.$refs.list.searchRefresh();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function changeSort(_x2) {
        return _changeSort.apply(this, arguments);
      }

      return changeSort;
    }()
  }
};